import axios from "axios";
import common from "./common";
import { Message} from 'element-ui';

// let loading        //定义loading变量

// function startLoading() {    //使用Element loading-start 方法
//     loading = Loading.service({
//       lock: true,
//       text: '',
//       background: 'rgba(0, 0, 0, 0)'
//   })
// }
// function endLoading() {    //使用Element loading-close 方法
//     loading.close()
// }

// let needLoadingRequestCount = 0;

// function showFullScreenLoading() {
//   if (needLoadingRequestCount === 0) {
//       startLoading()
//   }
//   needLoadingRequestCount++
// }

// function tryHideFullScreenLoading() {
//   if (needLoadingRequestCount <= 0) return
//   needLoadingRequestCount--
//   if (needLoadingRequestCount === 0) {
//       endLoading()
//   }
// }


class HttpRequest {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
    this.queue = {};
  }

  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${common.getToken() || ''}`
      }
    };
    return config;
  }

  destroy(url) {
    delete this.queue[url];
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }

  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      config => {
        // 添加全局的loading...
        if (!Object.keys(this.queue).length) {
          // Spin.show() // 不建议开启，因为界面不友好
          // showFullScreenLoading()
        }
        this.queue[url] = true;
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );
    // 响应拦截
    instance.interceptors.response.use(
      res => {
        this.destroy(url);
        if (res.data.code !== 0) {
          Message.error(`${res.data.msg}`);
          if(res.data.code === 76220 || res.data.code === 76210){
            common.setUserInfo('');
            common.setToken('');
          }
        }
        const { data, status } = res;
        // tryHideFullScreenLoading()
        return { data, status };
      },
      error => {
        this.destroy(url);
        return Promise.reject(error);
      }
    );
  }

  request(options) {
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(), options);
    this.interceptors(instance, options.url);
    return instance(options);
  }
}

// 环境的切换
let config = {
  baseUrl: {
    // dev: "http://gifteekaapi.test.eeka.info/api", //uat服务器
    // dev: "http://10.12.100.6:19230/api", //盛鹏本地服务器
    dev: "http://msi.eeka.info/api/eeka-gift-api-prod",// 生产服务器
    // pro: "http://gifteekaapi.test.eeka.info/api" // 测试环境
    pro: "http://msi.eeka.info/api/eeka-gift-api-prod" //生产环境
  }
};
const baseUrl =
  process.env.NODE_ENV === "development"
    ? config.baseUrl.dev
    : config.baseUrl.pro;
const http = new HttpRequest(baseUrl);
export default http;
